<template>
  <div class="pb-5">
    <div class="jm-white-container">
      <div class="col-lg-10 mx-auto">
        <section>
          <div class="row">
            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    id="on"
                    class="inputText"
                    v-model="organizationSetting.org_name"
                    name="Organization Name"
                    placeholder="."
                    v-validate="{
                      required: 'required',
                      regex: /^[a-zA-Z0-9 ]*$/
                    }"
                  />
                  <label for="on">Organization Name*</label>
                </div>
                <Tooltip :title="`You Organization name`" />
              </div>
              <p
                v-if="submitted && errors.has('Organization Name')"
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${"Organization Name"}`) }}
              </p>
              <!-- <p class="error_msg">Please enter valid name</p> -->
            </div>

            <div class="col-md-6 mb-4">
              <div class="row">
                <div class="col-10 pr-0">
                  <div class="d-flex align-items-center">
                    <label for="file-selector" class="file-selector w-100">
                      <div class="text-truncate">
                        {{ organizationSetting.org_logo }}
                      </div>
                      <input
                        type="file"
                        class="d-none"
                        id="file-selector"
                        name="file-selector"
                        placeholder="Upload logo"
                        v-on:change="___uploadImage($event)"
                      />
                    </label>

                    <Tooltip
                      :title="
                        `Logo should be of dimension 300x300 pixels, not more than 2mb of size & supported file types are png, jpg, jpeg, svg`
                      "
                    />
                  </div>
                </div>
                <div class="col-2">
                  <img
                    width="40"
                    height="40"
                    class="rounded"
                    @click="showOrginizationImage()"
                    v-lazy="BASE_URL + organizationSetting.org_logo"
                    v-if="organizationSetting.org_logo.length > 0"
                  />
                  <img
                    v-else
                    width="35"
                    height="35"
                    alt="Empty Image"
                    class="rounded"
                    src="@/assets/img/icons/empty-image.svg"
                  />
                </div>
              </div>

              <p
                v-if="
                  submitted && organizationSetting.org_logo == 'Upload Logo'
                "
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                Please Select Image File.
              </p>
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    id="rn"
                    v-model="organizationSetting.registartion_number"
                    placeholder="."
                    name="registration number"
                    v-validate="{
                      required: 'required',
                      regex: /^[a-zA-Z0-9 ]*$/
                    }"
                  />
                  <label for="rn">Registration Number</label>
                </div>
                <Tooltip :title="`Your organization registered number.`" />
              </div>
              <p
                v-if="submitted && errors.has('registration number')"
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${"registration number"}`) }}
              </p>
              <!-- <p class="error_msg">Invalid Path</p> -->
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    id="ea"
                    v-model="organizationSetting.email_address"
                    placeholder="."
                    name="EmailAddress"
                    v-validate="'required|email'"
                  />
                  <label for="ea">Email Address</label>
                </div>
                <Tooltip :title="`Official email address for communication`" />
              </div>
              <p
                v-if="submitted && errors.has('EmailAddress')"
                class="error_message"
              >
                <!-- {{ item.fieldname }} -->
                {{ errors.first(`${"EmailAddress"}`) }}
              </p>
              <!-- <p class="error_msg">Invalid Email</p> -->
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <!-- <b-dropdown
                  :text="SelectedCountryCode"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-50"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(countrycode, countryIndex) in Countries"
                    :key="countryIndex"
                    v-on:click="onSelectHandler('countrycode',countrycode)"
                  >{{ countrycode.country_mob_code }}</b-dropdown-item>
                </b-dropdown>-->
                <multiselect
                  :options="Countries"
                  :searchable="true"
                  :placeholder="
                    SelectedCountryCode && SelectedCountryCode.length > 0
                      ? SelectedCountryCode
                      : 'Country Code'
                  "
                  label="country_mob_code"
                  track-by="country_id"
                  @select="onSelectHandler('countrycode', $event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
                <div class="input-material w-100">
                  <input
                    type="text"
                    id="contact_no"
                    name="contact_no"
                    v-validate="'required|numeric|max:16'"
                    v-model="organizationSetting.contact_number"
                    placeholder="."
                  />
                  <label for="cn">Contact No</label>
                </div>
                <Tooltip :title="`Contact number for communication`" />
              </div>
              <p
                v-if="submitted && errors.has('contact_no')"
                class="error_message"
              >
                {{ errors.first(`${"contact_no"}`) }}
              </p>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    id="telephone_no"
                    name="telephone_no"
                    v-validate="'required|numeric|max:16'"
                    v-model="organizationSetting.telephone_no"
                  />
                  <label for="cn">Telephone No</label>
                </div>
                <Tooltip :title="`telephone number for communication`" />
              </div>
              <p
                v-if="submitted && errors.has('telephone_no')"
                class="error_message"
              >
                {{ errors.first(`${"telephone_no"}`) }}
              </p>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>
          </div>
        </section>

        <hr class="my-5" />

        <!-- ADDRESS SETTING -->
        <section>
          <div class="section-title mb-3">Address</div>
          <div class="row">
            <div class="col-md-6 mb-4" style="padding-right:45px;">
              <div class="input-material">
                <!-- <textarea cols="30" rows="7" placeholder="Registered Office"></textarea> -->
                <input
                  type="text"
                  id="ro"
                  v-model="organizationSetting.registred_office"
                  placeholder="."
                  name="Registered Office"
                  v-validate="{ required: 'required' }"
                />
                <label for="ro">Registered Office</label>
              </div>

              <p
                v-if="submitted && errors.has('Registered Office')"
                class="error_message"
              >
                {{ errors.first(`${"Registered Office"}`) }}
              </p>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    id="pincode"
                    v-model="organizationSetting.pincode"
                    placeholder="."
                    name="pincode"
                    v-validate="'required|alpha_num|max:10'"
                  />
                  <label for="pincode">ZipCode</label>
                  <p
                    v-if="submitted && errors.has('pincode')"
                    class="error_message"
                  >
                    <!-- {{ item.fieldname }} -->
                    {{ errors.first(`${"pincode"}`) }}
                  </p>
                </div>

                <Tooltip
                  :title="`City where the registered office is located`"
                />
              </div>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <!-- <b-dropdown
                  :text="selectedCountry.label"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-100"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(country, countryIndex) in Countries"
                    :key="countryIndex"
                    v-on:click="onSelectHandler('country',country)"
                  >{{ country.country_name }}</b-dropdown-item>
                </b-dropdown>-->
                <multiselect
                  :options="Countries"
                  :searchable="true"
                  :placeholder="
                    selectedCountry.label && selectedCountry.label.length > 0
                      ? selectedCountry.label
                      : 'Select Country'
                  "
                  label="country_name"
                  track-by="country_id"
                  @select="onSelectHandler('country', $event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
                <Tooltip
                  :title="`Country where the registered office is located`"
                />
              </div>
              <p
                v-if="submitted && selectedCountry.label == 'Select Country'"
                class="error_message"
              >
                Please Select Country.
              </p>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <!-- <b-dropdown
                  :text="selectedState.label"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(state,stateIndex) in States"
                    :key="stateIndex"
                    href="#"
                    @click="onSelectHandler('state',state)"
                  >{{ state.state_name }}</b-dropdown-item>
                </b-dropdown>-->
                <multiselect
                  :options="States"
                  :searchable="true"
                  :placeholder="
                    selectedState.label && selectedState.label.length > 0
                      ? selectedState.label
                      : 'Select State'
                  "
                  label="state_name"
                  track-by="state_id"
                  @select="onSelectHandler('state', $event)"
                  :allowEmpty="true"
                  :showLabels="false"
                ></multiselect>
                <Tooltip
                  :title="`State where the registered office is located`"
                />
              </div>
              <!-- <p
                v-if="submitted && selectedState.label == 'Select State'"
                class="error_message"
              >Please Select State.</p>
              <p class="error_msg">Invalid Entry</p> -->
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    id="city_name"
                    v-model="organizationSetting.city_name"
                    placeholder="."
                    name="City_name"
                  />
                  <label for="city_name">City</label>
                </div>
                <Tooltip
                  :title="`State where the registered office is located`"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    id="latitude_setup"
                    v-model="organizationSetting.latitude"
                    placeholder="."
                    name="latitude_setup"
                    v-validate="'decimal'"
                  />
                  <!-- v-validate="'required|decimal:4|alpha'" -->
                  <label for="latitude">Latitude</label>
                </div>
                <Tooltip :title="`This is for google location`" />
              </div>
              <p
                v-if="submitted && errors.has('latitude_setup')"
                class="error_message"
              >
                {{ errors.first(`${"latitude_setup"}`) }}
              </p>
              <!-- <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>

            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <div class="input-material w-100">
                  <input
                    type="text"
                    id="longitude_setup"
                    v-model="organizationSetting.longitude"
                    placeholder="."
                    name="longitude_setup"
                    v-validate="'decimal'"
                  />
                  <label for="longitude">Longitude</label>
                </div>
                <Tooltip :title="`This is for google location`" />
              </div>
              <p
                v-if="submitted && errors.has('longitude_setup')"
                class="error_message"
              >
                {{ errors.first(`${"longitude_setup"}`) }}
              </p>
              <!-- <p class="error_msg">Invalid Entry</p> -->
            </div>

            <div class="col-md-6">
              <div class="d-flex align-items-center">
                <!-- <b-dropdown
                  :text="selectedApplicationCurrentCountry.label"
                  variant="dropdown-curve-lg bg-theme-light"
                  class="w-100"
                >
                  <b-dropdown-item
                    v-for="(country, countrykey) in Countries"
                    :key="countrykey"
                    v-on:click="onSelectHandler('applicationCurrentCountry',country)"
                  >{{country.country_name}}</b-dropdown-item>
                </b-dropdown>-->
                <multiselect
                  :options="Countries"
                  :searchable="true"
                  :placeholder="
                    selectedApplicationCurrentCountry.label &&
                    selectedApplicationCurrentCountry.label.length > 0
                      ? selectedApplicationCurrentCountry.label
                      : 'Select Installation Country'
                  "
                  label="country_name"
                  track-by="country_id"
                  @select="onSelectHandler('applicationCurrentCountry', $event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
              <p
                v-if="
                  submitted &&
                    selectedApplicationCurrentCountry.label ==
                      'Select Installation Country'
                "
                class="error_message"
              >
                Please Select Installation Country.
              </p>
            </div>
          </div>
        </section>

        <hr class="my-5" />

        <!-- APPLICATION SETTING -->
        <section>
          <div class="section-title mb-3">Application Setting</div>
          <div class="row">
            <div
              class="col-12 mb-4"
              v-for="(item, index) in applicationSetting"
              :key="index"
            >
              <div class="row">
                <!-- IMAGE DIMENSION -->
                <div class="col-md-3">
                  <!-- <b-dropdown
                    :text="item.country_name"
                    variant="dropdown-curve-lg bg-theme-light"
                    class="w-100"
                  >
                    <b-dropdown-item
                      v-for="(country, countrykey) in Countries"
                      :key="countrykey"
                      v-on:click="onSelectHandler('applicationCountry',country,index)"
                    >{{country.country_name}}</b-dropdown-item>
                  </b-dropdown>-->
                  <multiselect
                    :options="Countries"
                    :searchable="true"
                    :placeholder="
                      item.country_name && item.country_name.length > 0
                        ? item.country_name
                        : 'Select Country'
                    "
                    label="country_name"
                    track-by="country_id"
                    @select="
                      onSelectHandler('applicationCountry', $event, index)
                    "
                    :allowEmpty="false"
                    :showLabels="false"
                  ></multiselect>
                  <p
                    v-if="submitted && item.country_name == 'Select Country'"
                    class="error_message"
                  >
                    Please Select Country.
                  </p>
                </div>

                <div class="col-md-9">
                  <div class="row">
                    <!-- ss -->
                    <div class="col-md-4">
                      <!-- <b-dropdown
                        :text="item.curr_name"
                        variant="dropdown-curve-lg bg-theme-light"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-for="(currency, currencykey) in Currencies"
                          :key="currencykey"
                          v-on:click="onSelectHandler('applicationCurrency',currency,index)"
                        >{{currency.curr_name}}</b-dropdown-item>
                      </b-dropdown>-->
                      <multiselect
                        :options="Currencies"
                        :searchable="true"
                        :placeholder="
                          item.curr_name && item.curr_name.length > 0
                            ? item.curr_name
                            : 'Select Currency'
                        "
                        label="curr_name"
                        track-by="curr_id"
                        @select="
                          onSelectHandler('applicationCurrency', $event, index)
                        "
                        :allowEmpty="false"
                        :showLabels="false"
                      ></multiselect>
                      <p
                        v-if="submitted && item.curr_name == 'Select Currency'"
                        class="error_message"
                      >
                        Please Select Currency.
                      </p>
                    </div>
                    <div class="col-md-5">
                      <multiselect
                        v-model="item.languages"
                        track-by="lang_name"
                        label="lang_name"
                        :options="Langugaes"
                        :multiple="true"
                      ></multiselect>
                      <p
                        v-if="submitted && item.languages.length <= 0"
                        class="error_message"
                      >
                        Please Select Options.
                      </p>
                    </div>

                    <div class="col-md-2 text-right pt-2">
                      <button
                        class="btn-transparent"
                        v-if="index === 0"
                        v-on:click="increaseApplicationSettingRow()"
                      >
                        <img
                          src="@/assets/img/icons/plus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                      <button
                        v-else
                        @click="decreaseApplicationSettingRow(index)"
                        class="btn-transparent"
                      >
                        <img
                          src="@/assets/img/icons/minus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <hr class="my-5" />

        <!-- IMAGE SETTING -->
        <section>
          <div class="section-title mb-3">Image Settings</div>

          <div class="row">
            <div
              class="col-12"
              v-for="(item, index) in imageSettingList"
              :key="index"
            >
              <div class="row">
                <!-- IMAGE DIMENSION -->
                <div class="col-md-4 mb-4">
                  <div class="d-flex align-items-center">
                    <div class="input-material w-100">
                      <input
                        type="text"
                        v-model="item.image_name"
                        :id="'A' + index"
                        placeholder="."
                        :name="'image setting name' + index"
                        v-validate="'required'"
                      />

                      <label :for="'A' + index">Image Settings Name</label>
                    </div>
                    <Tooltip
                      :title="
                        `Add all dimensions of images that would be used in the system`
                      "
                    />
                  </div>

                  <p
                    v-if="submitted && errors.has('image setting name' + index)"
                    class="error_message"
                  >
                    Please enter Image Setting Name.
                    <!-- {{ errors.first(`${'image setting name' + index}`)}} -->
                  </p>
                </div>
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="input-material mw-auto">
                        <input
                          type="text"
                          v-model="item.image_height"
                          :id="'B' + index"
                          placeholder="."
                          :name="'height' + index"
                          v-validate="'required|numeric'"
                        />
                        <label :for="'B' + index">Height</label>
                      </div>
                      <p
                        v-if="submitted && errors.has('height' + index)"
                        class="error_message"
                      >
                        <!-- {{ item.fieldname }} -->
                        <!-- {{errmsg}} -->
                        Please enter Height.
                        <!-- {{ errors.first(`${'height' + index}`)}} -->
                      </p>
                    </div>
                    <div class="col-md-3">
                      <div class="input-material mw-auto">
                        <input
                          type="text"
                          v-model="item.image_width"
                          :id="'C' + index"
                          placeholder="."
                          :name="'width' + index"
                          v-validate="'required|numeric'"
                        />
                        <label :for="'C' + index">width</label>
                      </div>
                      <p
                        v-if="submitted && errors.has('width' + index)"
                        class="error_message"
                      >
                        <!-- {{ item.fieldname }} -->
                        <!-- {{errmsg}} -->
                        Please enter Width.
                      </p>
                    </div>
                    <!-- <div class="col-md-4">
                      <b-dropdown
                        :text="item.fixed_ratio"
                        variant="dropdown-curve-lg bg-theme-light"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-for="(ratio, ratiokey) in fixedRatios"
                          :key="ratiokey"
                          v-on:click="onSelectHandler('fixed_ratio',ratio,index)"
                        >{{ratio}}</b-dropdown-item>
                      </b-dropdown>
                      <p
                        v-if="submitted && item.fixed_ratio == 'Select Fixed Ratio'"
                        class="error_message"
                      >Please Select Fixed Ratio.</p>
                    </div>-->

                    <div class="col-md-2 text-right pt-2">
                      <button
                        class="btn-transparent"
                        v-if="index === 0"
                        v-on:click="increaseImageSettingRow()"
                      >
                        <img
                          src="@/assets/img/icons/plus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                      <button
                        v-else
                        @click="decreaseImageSettingRow(index)"
                        class="btn-transparent"
                      >
                        <img
                          src="@/assets/img/icons/minus.svg"
                          height="35"
                          width="35"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- NAVIGATIONS -->
        <section>
          <div class="text-center">
            <!-- <router-link to="select-installation-type" class="btn-outline-blue-lg w-25">Back</router-link> -->
            <router-link
              v-if="IsUpdate"
              to="add-cinema-master"
              class="btn-outline-blue-lg w-25"
              >Next</router-link
            >
            <router-link
              to
              v-on:click.native="onSubmit()"
              class="btn-blue-lg w-25"
              >{{ BtnText }}</router-link
            >
            <!--  -->
            <!-- to="add-cinema-master" -->
          </div>
        </section>
      </div>
    </div>

    <!-- SHOW ORGANIZATION MODAL -->
    <!-- MOVIE POSTER IMAGE MODAL -->
    <b-modal
      size="lg"
      hide-footer
      ref="preview-modal"
      title="Organization Logo"
      id="selected-image-preview-modal"
    >
      <img :src="BASE_URL + organizationSetting.org_logo" class="img-fluid" />
    </b-modal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import UserService from "@/services/UserService";
import MasterService from "@/services/MasterService";
import SetupService from "@/services/SetupService";
import saveState from "vue-save-state";

const applicationSettingObjects = {};

export default {
  // name: "Setup Organization",
  mixins: [saveState],
  components: { Multiselect },
  data() {
    return {
      // JAY
      tempModalImageName: null,
      // JAY
      SelectedCountryCode: "Country Code",
      errmsg: "",
      submitted: false,
      BtnText: "Next",
      IsUpdate: false,
      BaseURL: "",
      organizationSetting: {
        org_name: "",
        org_logo: "Upload Logo",
        registartion_number: "",
        email_address: "",
        contact_number: "",
        number_of_cinemas: "1",
        registred_office: "",
        pincode: "",
        latitude: "",
        longitude: "",
        city_name: ""
      },
      applicationSetting: [
        {
          country_name: "Select Country",
          country: "",
          curr_name: "Select Currency",
          currency: "",
          languages: []
        }
      ],
      imageSettingList: [
        {
          image_name: "",
          image_height: "",
          image_width: ""
        }
      ],
      fixedRatios: ["16:9", "4:3", "21:9"],
      selected: null,
      selectedApplicationCountry: {
        label: "Select Country",
        value: ""
      },
      selectedApplicationCurrentCountry: {
        label: "Select Installation Country",
        value: ""
      },
      selectedApplicationCurrency: {
        label: "Select Currency",
        value: ""
      },
      selectedApplicationLanguage: {
        label: "Select Language",
        value: []
      },
      options: ["India", "UAE", "USA", "UK", "China", "Sri Lanka"],
      selectedCountry: {
        label: "Select Country",
        value: ""
      },
      Countries: [],
      CountriesMethod: {
        GET: "/admin/",
        tableName: "ms_countries",
        urlKey: "countries"
      },
      selectedState: {
        label: "Select State",
        value: ""
      },
      States: [],
      StatesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_states",
        urlKey: "states"
      },
      selectedCity: {
        label: "Select City",
        value: ""
      },
      Cities: [],
      CitiesMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cities",
        urlKey: "cities"
      },
      Currencies: [],
      CurrencyMethod: {
        GET: "/admin/",
        tableName: "ms_currencies",
        urlKey: "currencies"
      },
      Langugaes: [],
      LangugaeMethod: {
        GET: "/admin/",
        tableName: "ms_language",
        urlKey: "languages"
      }
    };
  },
  beforeMount() {
    this.getSetupStatus();
  },
  mounted() {
    this.getOrgName();
    // this.organizationSetting.org_name = this.secureStore.get("ORGNAME");
    this.getCountriesList();
    // this.increaseImageSettingRow();
    // this.increaseApplicationSettingRow();
    this.getCurrencies();
    this.getLanguages();
  },
  methods: {
    getSetupStatus: function() {
      SetupService.SetupStatus()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (!data.isSetupAllowed) {
              this.$router.push({
                path: data.route
              });
            }
          } else {
            this.$router.push({
              name: "Error404"
            });
          }
        })
        .catch(err => {
          this.$router.push({
            name: "Error404"
          });
        });
    },
    showOrginizationImage: function() {
      console.log("clicked");
      this.$refs["preview-modal"].show();
    },
    getSaveStateConfig() {
      return {
        cacheKey: "Setup Organization"
      };
    },
    getOrgName: function() {
      SetupService.GetOrgName()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.organizationSetting.org_name = data.Records[0].go_value;
          }
        })
        .catch(err => {
          console.log("err :", err);
        });
    },
    onSelectHandler: function(type, value, index) {
      if (type == "gender") {
        this.selectedGender.label = value.gender;
        this.selectedGender.value = value.gender_id;
      } else if (type == "country") {
        this.selectedCountry.label = value.country_name;
        this.selectedCountry.value = value.country_id;
        this.organizationSetting["country"] = value.country_id;
        this.getStatesList(value.country_id);
      } else if (type == "countrycode") {
        this.SelectedCountryCode = value.country_mob_code;
      } else if (type == "state") {
        this.selectedState.label = value.state_name;
        this.selectedState.value = value.state_id;
        this.organizationSetting["state"] = value.state_id;
        this.getCitiesList(value.state_id);
      } else if (type == "city") {
        this.selectedCity.label = value.city_name;
        this.selectedCity.value = value.city_id;
        this.organizationSetting["city"] = value.city_id;
      } else if (type == "role") {
        this.selectedRole.label = value.role_name;
        this.selectedRole.value = value.role_id;
      } else if (type == "designation") {
        this.selectedDesignation.label = value.designation;
        this.selectedDesignation.value = value.designation_id;
      } else if (type == "cinema") {
        this.selectedCinema.label = value.cine_name;
        this.selectedCinema.value = value.cine_id;
      } else if (type == "applicationCountry") {
        this.selectedApplicationCountry.label = value.country_name;
        this.selectedApplicationCountry.value = value.country_id;
        this.applicationSetting[index].country = value.country_id;
        this.applicationSetting[index].country_name = value.country_name;
      } else if (type == "applicationCurrentCountry") {
        this.selectedApplicationCurrentCountry.label = value.country_name;
        this.selectedApplicationCurrentCountry.value = value.country_id;
        this.organizationSetting["installation_country"] = value.country_id;
      } else if (type == "applicationCurrency") {
        this.selectedApplicationCurrency.label = value.curr_name;
        this.selectedApplicationCurrency.value = value.curr_id;
        this.applicationSetting[index].currency = value.curr_id;
        this.applicationSetting[index].curr_name = value.curr_name;
      }
      // else if (type === "fixed_ratio") {
      //   this.imageSettingList[index].fixed_ratio =
      //     this.imageSettingList[index].image_height /
      //     this.imageSettingList[index].image_width;

      // }
      // else if (type === "noc") {
      //   this.organizationSetting["number_of_cinemas"] = 1;
      // }
    },
    getCurrencies: function() {
      this.Currencies = [];
      let body = this.getRequestBody("GET", undefined, this.CurrencyMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Currencies = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getLanguages: function() {
      this.Langugaes = [];
      let body = this.getRequestBody("GET", undefined, this.LangugaeMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Langugaes = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCountriesList: function() {
      this.Countries = [];
      this.options = [];
      let body = this.getRequestBody("GET", undefined, this.CountriesMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Countries = data.Records;
            for (var i = 0; i < this.Countries.length; i++) {
              this.options.push(this.Countries[i].country_name);
            }
            // this.options = data.Records.filter(x => {
            //   return x.country_name;
            // });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getStatesList: function(country_id) {
      this.States = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.StatesMethod,
        params: { id: "country_id-" + country_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.States = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    getCitiesList: function(state_id) {
      this.Cities = [];
      let body = this.getRequestBody("GET", undefined, {
        ...this.CitiesMethod,
        params: { id: "state_id-" + state_id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cities = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    increaseApplicationSettingRow: function() {
      this.applicationSetting.push({
        country_name: "Select Country",
        //   country_name: "",
        country: "",
        curr_name: "Select Currency",
        //curr_name: "",
        currency: "",
        languages: []
      });
    },
    increaseImageSettingRow: function() {
      this.imageSettingList.push({
        image_name: "",
        image_height: "",
        image_width: ""
        // fixed_ratio: "Select Fixed Ratio"
      });
    },
    decreaseImageSettingRow: function(index) {
      this.imageSettingList.splice(index, 1);
    },
    decreaseApplicationSettingRow: function(index) {
      this.applicationSetting.splice(index, 1);
    },
    uploadImage: function(image) {
      let self = this;
      let formData = new FormData();
      formData.append("image", image.target.files[0]);
      formData.append("imagePath", "Organization Image");
      MasterService.GlobalUploadImage(formData)
        .then(response => {
          const { data } = response;
          data.message ? this.$toasted.show(data.message) : "";
          if (data.status) {
            self.organizationSetting.org_logo = data.path;
            this.$store.dispatch("setOrgImage", data.path);
          }
          self.BaseURL = data.BaseURL;
        })
        .catch(error => {
          alert(
            "Sorry! Something went wrong. kindly contact your administrator"
          );
        });
    },
    ___uploadImage: function(event) {
      let self = this;
      let _URL = window.URL || window.webkitURL;
      let file, img;
      if ((file = event.target.files[0])) {
        img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = async () => {
          console.log("img.width :", img.width, img.height);
          if (img.width != parseInt(300) || img.height != parseInt(300)) {
            console.log("event :", event);
            let f = self.$refs["UploadOragnizationLogo"];
            self.organizationSetting.org_logo = "Upload Logo";
            self.$toasted.show("Please upload 300*300 image logo");
          } else {
            let formData = new FormData();
            formData.append("image", event.target.files[0]);
            formData.append("imagePath", "Organization Image");
            MasterService.SetupUploadImage(formData)
              .then(response => {
                const { data } = response;
                data.message ? this.$toasted.show(data.message) : "";
                if (data.status) {
                  self.organizationSetting.org_logo = data.path;
                  this.$store.dispatch("setOrgImage", data.path);
                }
                self.BaseURL = data.BaseURL;
                event.target.value = "";
              })
              .catch(error => {
                this.$toasted.show(
                  "Sorry! Something went wrong. kindly contact your administrator"
                );
                // alert(
                //   "Sorry! Something went wrong. kindly contact your administrator"
                // );
              });
          }
        };
      }
    },
    onSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log(
          "this.organizationSetting.org_logo :",
          this.organizationSetting.org_logo
        );
        if (this.organizationSetting.org_logo == "Upload Logo") {
          return;
        } else {
          if (valid) {
            // this.$router.push({
            //   path: "add-cinema-master"
            // });
            // this.$store.dispatch(
            //   "setNumberOfCinemas",
            //   this.organizationSetting.number_of_cinemas
            // );
            this.organizationSetting.number_of_cinemas = 1;

            let payload = {
              organization: this.organizationSetting,
              applicationSetting: this.applicationSetting,
              imageSettingList: this.imageSettingList
              // to="add-cinema-master"
            };

            payload.configHeaders = {
              headers: {
                "content-type": "application/json",
                Authorization: window.localStorage.getItem("AUTH_KEY")
              }
            };
            SetupService.AddOrg(payload)
              .then(response => {
                const { data } = response;
                if (data.status) {
                  this.BtnText = "Update";
                  this.IsUpdate = true;
                  this.$router.push({
                    path: "add-cinema-master"
                  });
                  this.$store.dispatch("setCurrentCinemaIndex");

                  this.$store.dispatch(
                    "setNumberOfCinemas",
                    this.organizationSetting.number_of_cinemas
                  );
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(error => {
                // Show Catch Error
                this.$toasted.show(error || "Something went wrong");
                console.log("show error :", error);
              });
          }
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Installation/setupOrganization.vue